import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { ProductWarehouseStockLevel } from '../../../models/settings';

@Injectable({
  providedIn: 'root',
})
export class ProductWarehouseStockLevelService extends TmsWebBaseEditCreateService<
  ProductWarehouseStockLevel,
  ProductWarehouseStockLevel
> {
  constructor() {
    super('ProductWarehouseStockLevel', $localize`Stock Level`);
  }

  // The levels set for one product, across warehouses - the product's Stock Levels tab.
  getForProduct(productId: string): Observable<ProductWarehouseStockLevel[]> {
    return this.httpService.get<ProductWarehouseStockLevel[]>(`${this.apiUrl}/GetForProduct/${productId}`);
  }
}
